import React, { useEffect, useState } from "react";
import { usePageTracking } from "./analytics/usePageTracking";
import { useLocation, useRoutes } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { CacheProvider } from "@emotion/react";

import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import "./i18n";
import createTheme from "./theme";
import routes from "./routes";

import useTheme from "./hooks/useTheme";
import { store } from "./redux/store";
import createEmotionCache from "./utils/createEmotionCache";

import { AuthProvider } from "./contexts/JWTContext";
// import { AuthProvider } from "./contexts/FirebaseAuthContext";
// import { AuthProvider } from "./contexts/Auth0Context";
// import { AuthProvider } from "./contexts/CognitoContext";

import { useCheckAppVersion } from "./hooks/useCheckAppVersion";
import { Alert, Button, Snackbar } from "@mui/material";

const clientSideEmotionCache = createEmotionCache();

function App({ emotionCache = clientSideEmotionCache }) {
  const content = useRoutes(routes);
  usePageTracking();

  const { theme } = useTheme();
  const showUpdate = useCheckAppVersion();

  const [open, setOpen] = useState(true);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <CacheProvider value={emotionCache}>
      <HelmetProvider>
        <Helmet
          titleTemplate="Tiehoitokunta.fi - Tiesi asialla"
          defaultTitle="Tiehoitokunta.fi - Tiesi asialla"
        />
        <Provider store={store}>
          {/* @ts-ignore */}
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MuiThemeProvider theme={createTheme(theme)}>
              <AuthProvider>
                {content}

                {showUpdate && (
                  <Snackbar
                    open={open}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                  >
                    <Alert
                      severity="info"
                      action={
                        <Button
                          color="inherit"
                          size="small"
                          onClick={handleReload}
                        >
                          Päivitä
                        </Button>
                      }
                      onClose={() => setOpen(false)}
                    >
                      Uusi versio saatavilla. Päivitä nähdäksesi muutokset.
                    </Alert>
                  </Snackbar>
                )}
              </AuthProvider>
            </MuiThemeProvider>
          </LocalizationProvider>
        </Provider>
      </HelmetProvider>
    </CacheProvider>
  );
}

export default App;
